import React from 'react'
import { Tooltip } from 'react-daisyui'
import Icon from '../components/icons'
import Text from './Typo/Text'
import { TextSizeType } from '../_config/types'

const Label: React.FC<{
    text: string
    isBold?: boolean
    required?: boolean
    isCapitalize?: boolean
    isError?: boolean
    information?: string
    badge?: React.ReactNode
    position?: 'top' | 'right' | 'left' | 'bottom'
    labelTextSize?: TextSizeType
    className?: string
    htmlFor?: string
}> = ({ htmlFor, text, isBold, required, isCapitalize, isError, information, badge, labelTextSize = 'sm', className = '', position = 'top' }) => (
    <label htmlFor={htmlFor} className={`flex items-center h-[0.7rem] mb-[0.4rem] gap-1 ${className}`}>
        <Text size={labelTextSize} className={`${isBold ? 'font-bold' : 'font-normal'} ${isCapitalize ? 'capitalize' : ''} ${isError ? 'text-red-500' : ''} leading-none`}>
            {text}
            {required && <span className="text-red-500 ml-1">*</span>}
        </Text>
        {information && (
            <Tooltip message={information} color="info" position={position} className="whitespace-normal break-normal">
                <Icon name="outlineInfoCircle" size={'0.6'} />
            </Tooltip>
        )}
        {badge}
    </label>
)
export default Label
